"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _getBackground = require("../operators/getBackground");

var _getSize = require("../operators/getSize");

var _animation = require("../constants/animation");

var _useOptions = require("../constants/useOptions");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n  padding: ", ";\n\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonBase = _styledComponents.default.div.withConfig({
  displayName: "SkeletonBase",
  componentId: "sc-10ev0oz-0"
})(_templateObject(), function (_ref) {
  var margin = _ref.margin;
  return margin ? (0, _getSize.getSize)(margin) : undefined;
}, function (_ref2) {
  var padding = _ref2.padding;
  return padding ? (0, _getSize.getSize)(padding) : undefined;
}, function (_ref3) {
  var use = _ref3.use;
  return (0, _getBackground.getBackground)({
    use: use
  });
}, function (_ref4) {
  var use = _ref4.use;
  return use !== _useOptions.BLANK && _animation.animation;
});

SkeletonBase.defaultProps = {
  use: _useOptions.DEFAULT
};
SkeletonBase.propTypes = {
  margin: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  padding: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  use: _react.PropTypes.oneOf([_useOptions.DEFAULT, _useOptions.SHADE, _useOptions.DARK, _useOptions.BLANK])
};
var _default = SkeletonBase;
exports.default = _default;
module.exports = exports.default;